(function () {
  'use strict';

  const productSelector = '[data-section-type="product"][data-mobile-gallery-style="thumbnails"]';
  const thumbnailSelector = '[data-product-thumbnail]';
  const mobile = window.matchMedia('(width < 960px)');
  const labels = document.currentScript ? document.currentScript.dataset : {};
  const instances = new Map();

  function init(product) {
    if (instances.has(product)) return;

    let frame = null;
    let lastActive = null;
    let list = null;
    let gallery = null;

    function getThumbnails() {
      if (!list || !gallery) return [];
      return Array.from(list.querySelectorAll(thumbnailSelector)).filter(function (button) {
        const item = button.closest('li');
        if (!item || item.hidden || button.hidden || item.hasAttribute('data-al-media-placeholder')) return false;
        return Array.from(gallery.querySelectorAll('[data-media-item-id]')).some(function (media) {
          return media.dataset.mediaItemId === button.dataset.thumbnailId &&
            !media.hasAttribute('data-al-media-placeholder');
        });
      });
    }

    function createArrow(direction, label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'al-mobile-gallery-arrow al-mobile-gallery-arrow--' + direction;
      button.dataset.mobileGalleryDirection = direction;
      button.setAttribute('aria-label', label);
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.2"><path d="' +
        (direction === 'previous' ? 'M21 12H3m9-9-9 9 9 9' : 'M3 12h18m-9-9 9 9-9 9') + '"/></svg>';
      return button;
    }

    function sync() {
      frame = null;
      gallery = product.querySelector('.product__media');
      list = product.querySelector('[data-product-thumbnails]');
      if (!gallery) return;

      const thumbnails = getThumbnails();
      const single = thumbnails.length <= 1;
      if (list) list.toggleAttribute('data-mobile-single-media', single);

      if (!gallery.querySelector('[data-mobile-gallery-direction]') && !single) {
        gallery.appendChild(createArrow('previous', labels.previousLabel || 'Previous slide'));
        gallery.appendChild(createArrow('next', labels.nextLabel || 'Next slide'));
      }
      gallery.querySelectorAll('[data-mobile-gallery-direction]').forEach(function (button) {
        if (button.hidden !== single) button.hidden = single;
      });

      const active = thumbnails.find(function (button) { return button.classList.contains('active'); });
      thumbnails.forEach(function (button) {
        if (button === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });

      product.setAttribute('data-al-mobile-gallery-ready', '');
      if (mobile.matches && active && active !== lastActive) {
        // Scroll only the pagination strip, never the surrounding page.
        const bounds = active.getBoundingClientRect();
        const listBounds = list.getBoundingClientRect();
        if (bounds.left < listBounds.left || bounds.right > listBounds.right) {
          list.scrollLeft += bounds.left - listBounds.left - (list.clientWidth - bounds.width) / 2;
        }
      }
      lastActive = active;
    }

    function schedule() {
      if (frame == null) frame = window.requestAnimationFrame(sync);
    }

    function onClick(event) {
      const arrow = event.target.closest('[data-mobile-gallery-direction]');
      if (!arrow || !product.contains(arrow) || !mobile.matches) return;
      event.preventDefault();
      event.stopPropagation();
      const thumbnails = getThumbnails();
      if (thumbnails.length <= 1) return;
      const current = thumbnails.findIndex(function (button) { return button.classList.contains('active'); });
      const step = arrow.dataset.mobileGalleryDirection === 'next' ? 1 : -1;
      const next = (Math.max(0, current) + step + thumbnails.length) % thumbnails.length;
      thumbnails[next].click();
      schedule();
    }

    function onViewportChange() {
      lastActive = null;
      schedule();
    }

    const observer = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.type === 'childList' || record.target.closest('.product__media-container');
      })) schedule();
    });
    observer.observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    product.addEventListener('click', onClick);
    mobile.addEventListener('change', onViewportChange);
    instances.set(product, function () {
      observer.disconnect();
      if (frame != null) window.cancelAnimationFrame(frame);
      product.removeEventListener('click', onClick);
      mobile.removeEventListener('change', onViewportChange);
      instances.delete(product);
    });
    sync();
  }

  function scan(root) {
    if (root.matches && root.matches(productSelector)) init(root);
    root.querySelectorAll(productSelector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, product) {
      if (event.target === product || event.target.contains(product)) dispose();
    });
  });
})();
